import { QpLazyImage } from "./qp-lazy-image.directive";
import "./assets/qp-lazy-image.less"

let module_name = "qp-lazy-image";
angular.module(module_name, []).directive({
    qpLazyImage: QpLazyImage
})

export { module_name }